<div>
  ソート順
  <select class="form-control-sm d-inline" [formControl]="sortTarget">
    <option *ngFor="let target of sortTargetValue" [ngValue]="target.value">{{target.name}}</option>
  </select>
  <ng-container *ngIf="sortOrder.value === 1; then ascButton; else descButton"></ng-container>
  <ng-template #descButton>
    <button class="ml-2 btn btn-info btn-sm" (click)="sortOrder.setValue(1)">
      <fa-icon icon="sort-amount-up"></fa-icon>
    </button>
  </ng-template>
  <ng-template #ascButton>
    <button class="ml-2 btn btn-info btn-sm" (click)="sortOrder.setValue(-1)">
      <fa-icon icon="sort-amount-down"></fa-icon>
    </button>
  </ng-template>
</div>
